// @ts-strict-ignore
import { createReducer, on } from '@ngrx/store';
import { Customer } from '@fc-core';
import * as customerActions from '../actions';

export interface State {
  loading: boolean;
  currentCustomer: Customer;
  error: any;
}

export const initialState: State = {
  loading: false,
  currentCustomer: null,
  error: null,
};

export const reducer = createReducer(
  initialState,
  on(customerActions.loadCurrentCustomerActionSuccess, (state, action) => ({
    ...state,
    currentCustomer: action.customer,
    loading: false,
  })),

  on(customerActions.updateCurrentCustomerActionError, (state, action) => ({
    ...state,
    error: action.err,
    loading: false,
  })),
  on(
    customerActions.loadCurrentCustomerActionError,
    customerActions.updateCurrentCustomerActionSuccess,
    (state) => ({
      ...state,
      loading: false,
    }),
  ),

  on(customerActions.updateCurrentCustomerAction, (state) => ({
    ...state,
    loading: true,
  })),
);

export const getCurrentCustomerLoading = (state: State) => state.loading;
export const getCurrentCustomer = (state: State) => state.currentCustomer;
export const getCurrentCustomerError = (state: State) => state.error;
